import { render, staticRenderFns } from "./TopNotice.vue?vue&type=template&id=d2661a9c&scoped=true&"
import script from "./TopNotice.vue?vue&type=script&lang=js&"
export * from "./TopNotice.vue?vue&type=script&lang=js&"
import style0 from "./TopNotice.vue?vue&type=style&index=0&id=d2661a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2661a9c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/TopNotice.vue
// module id = null
// module chunks = 